module.exports = __webpack_public_path__ + "images/thumb-b19d5d192f252b89de496bd2f1099efb.jpg";